import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5c57dc26"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "contact" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "contact-text" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "Contact Us"),
    /*#__PURE__*/_createElementVNode("p", null, "We usually reply within two business days")
  ])
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "form-text" }, "Contact Form", -1))
const _hoisted_3 = { class: "form" }
const _hoisted_4 = { class: "form-item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "fullname" }, "Full Name", -1))
const _hoisted_6 = { class: "form-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email", -1))
const _hoisted_8 = { class: "form-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "phone" }, "Phone Number", -1))
const _hoisted_10 = { class: "form-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "topic" }, "Topic", -1))
const _hoisted_12 = { class: "form-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "message" }, "Message", -1))
const _hoisted_14 = {
  class: "mt-3",
  type: "submit"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Navbar),
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("form", {
        class: "contact-form",
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.contact_us && _ctx.contact_us(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.contact.fullname) = $event)),
            placeholder: "Enter Full Name",
            id: "fullname"
          }, null, 512), [
            [_vModelText, _ctx.contact.fullname]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.fullname.$errors, (error) => {
            return (_openBlock(), _createElementBlock("span", {
              key: error.$uid,
              class: "error"
            }, _toDisplayString(error.$message), 1))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            type: "email",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.contact.email) = $event)),
            placeholder: "Enter your email",
            id: "email"
          }, null, 512), [
            [_vModelText, _ctx.contact.email]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.email.$errors, (error) => {
            return (_openBlock(), _createElementBlock("span", {
              key: error.$uid,
              class: "error"
            }, _toDisplayString(error.$message), 1))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            type: "tel",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.contact.phone) = $event)),
            placeholder: "Enter Phone Number",
            id: "phone"
          }, null, 512), [
            [_vModelText, _ctx.contact.phone]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.phone.$errors, (error) => {
            return (_openBlock(), _createElementBlock("span", {
              key: error.$uid,
              class: "error"
            }, _toDisplayString(error.$message), 1))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.contact.topic) = $event)),
            placeholder: "Enter a Subject",
            id: "topic"
          }, null, 512), [
            [_vModelText, _ctx.contact.topic]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.topic.$errors, (error) => {
            return (_openBlock(), _createElementBlock("span", {
              key: error.$uid,
              class: "error"
            }, _toDisplayString(error.$message), 1))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _withDirectives(_createElementVNode("textarea", {
            name: "message",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.contact.message) = $event)),
            id: "message",
            placeholder: "Enter your message"
          }, null, 512), [
            [_vModelText, _ctx.contact.message]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.message.$errors, (error) => {
            return (_openBlock(), _createElementBlock("span", {
              key: error.$uid,
              class: "error"
            }, _toDisplayString(error.$message), 1))
          }), 128))
        ]),
        _createElementVNode("button", _hoisted_14, _toDisplayString(_ctx.loader), 1)
      ], 32)
    ]),
    _hoisted_15,
    _createVNode(_component_Footer)
  ]))
}